import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, {Component, Fragment} from 'react';
import {actions as system} from '../reducers/system';
import {actions as labelCollection} from '../reducers/labelCollection';
import { Formik, Form, Field } from 'formik';
import Select from '../components/form/Select';
import _ from 'lodash';
import ScreenHeader from "../components/general/ScreenHeader";
import ProjectType from "../enums/ProjectType";
import {actions as label} from "../reducers/label";

@connect(
	state => {
		return {
			selectedLabelCollection: state.labelCollection.selected,
			selectedProject: state.project.selected
		}
	},
	dispatch => {
		return {
			clearMessages: () => dispatch(system.clearMessages()),
			createLabelCollection: (labelCollectionToCreate) => dispatch(labelCollection.create(labelCollectionToCreate)),
			updateLabelCollection: (labelCollectionToUpdate) => dispatch(labelCollection.update(labelCollectionToUpdate)),
		};
	})
export default class LabelCollectionForm extends Component
{

	constructor(props){
		super(props);

		this.state = {
			isUpdateMode: _.has(props.match.params, 'labelCollection')
		}
	}

	getRedirectPath() {
		return '/show/' + encodeURIComponent(this.props.selectedProject.name);
	}

	render() {
		if(!this.props.selectedProject) {
			return null;
		}

		const initialState = this.props.selectedLabelCollection ? {
			..._.omit(this.props.selectedLabelCollection, ['genericDisplayName']),
			languages: _.map(this.props.selectedLabelCollection.languages, 'identifier')
		} : {
			displayName: '',
			identifier: '',
			productName: '',
			original: '',
			defaultLanguage: '',
			allLanguages: true,
			languages: []
		};

		const languageCheckboxes = _.map(this.props.selectedProject.languages, (language, key) => {
			return (
				<Field name="languages" key={key}>
					{({field, form}) => (
						<div className="form-check xpull-left">
							<label className="form-check-label">
								<input
									className="form-check-input"
									type="checkbox"
									checked={_.includes(field.value, language)}
									onChange={() => {
										if (_.includes(field.value, language)) {
											form.setFieldValue('languages', _.without(field.value, language));
										} else {
											form.setFieldValue('languages', _.concat(field.value, language));
										}
									}}
								/>
								<span className="form-check-sign"/>
								{language}
							</label>
						</div>
					)}
				</Field>
			);
		});

		// when the form is to update wait with rendering until the project is loaded
		return this.state.isUpdateMode && this.props.selectedLabelCollection === null ? null : (
			<Fragment>
				<div className="card">
					<ScreenHeader value="Add LabelCollection" />

					<Formik
						initialValues={initialState}
						onSubmit={(labelCollection, actions) => {
							this.props.clearMessages();
							const promise = this.props.selectedLabelCollection ? this.props.updateLabelCollection(labelCollection) : this.props.createLabelCollection(labelCollection);
							promise.then(
								success => {
									if(success) {
										this.props.history.push(this.getRedirectPath());
									} else {
										actions.setSubmitting(false);
									}
								}
							);
						}}
						render={({ isSubmitting, values, setFieldValue }) => (
							<Form>
								<div className="card-body">
									<div className="form-group has-label">
										<label>Display Name</label>
										<Field placeholder={this.props.selectedLabelCollection ? this.props.selectedLabelCollection.genericDisplayName : ''} type="text" className="form-control" name="displayName" />
									</div>
									<div className="form-group has-label">
										<label>Identifier *</label>
										<Field type="text" className="form-control" name="identifier" />
									</div>
									{this.props.selectedProject.type !== ProjectType.TYPE_TYPO3 ? (
										<Fragment>
											<div className="form-group has-label">
												<label>Product-Name</label>
												<Field type="text" className="form-control" name="productName"/>
											</div>
											<div className="form-group has-label">
												<label>Original</label>
												<Field type="text" className="form-control" name="original"/>
											</div>
										</Fragment>
									) : null}

									<div className="form-check xpull-left">
										<label className="form-check-label">
											<Field name="allLanguages">
												{({field, form}) => (
													<input
														type="checkbox"
														className="form-check-input"
														checked={field.value}
														onChange={() => {
															form.setFieldValue('allLanguages', !field.value);
															if(field.value){
																setFieldValue('languages', []);
															}
														}}
													/>
												)}
											</Field>
											<span className="form-check-sign"/>
											All languages
										</label>
									</div>
									{ values.allLanguages ? null : (
										<div className="form-group has-label">
											<label>Languages</label>
											{languageCheckboxes}
										</div>
									)}
									<div className="form-group has-label">
										<label>Default language *</label>
										<Select name="defaultLanguage" options={
											_.map(values.allLanguages ? this.props.selectedProject.languages : values.languages, language => {
												return {value: language, label: language}
											})
										} />
									</div>
									<hr/>
								</div>

								<div className="card-footer text-right">
									<Link to={this.getRedirectPath()} className="btn btn-secondary">Cancel</Link>
									<button type="submit" className="btn btn-primary" disabled={isSubmitting}>
										{this.state.isUpdateMode ? 'Update labelCollection' : 'Add labelCollection'}
									</button>
								</div>
							</Form>
						)}
					/>
				</div>
			</Fragment>
		);
	};
}


// WEBPACK FOOTER //
// ./React/src/screens/LabelCollectionForm.js